import UserCategories from '../UserCategories';
import classes from './EditCategory.module.css';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { LanguageContext } from '../../../../context/LanguageContext';
import ComponentsTitle from '../../userAccountTitle/componentsTitle/ComponentsTitle';
import ChangeDataButtons from '../../../../components/user/editData/changeDataButtons/ChangeDataButtons';
import { useCurrentUser } from '../../../../hooks/useCurrentUser';
import editUserConfigs from '../../../../store/user/editConfigs/EditUserConfigs';
import Cookies from "js-cookie";
import { editUserConfigsAction } from '../../../../store/user/editConfigs/EditUserConfigsSlice';

const EditCategory = (props) => {
  const { setData, data, categoriesData } = props
  const dispatch = useDispatch();
  const [categoryData, setCategoryData] = useState([]);
  const { user, refetchUser } = useCurrentUser();
  const [editCategory, setEditCategory] = useState(false);
  const editUserConfigsData = useSelector((state) => state.editUserConfigs);
  const token = Cookies.get("auth_token");

  const cancel = (e) => {
    e.preventDefault();
    setEditCategory(false);
    setCategoryData(user?.categories);
  };

  useEffect(() => {
    setEditCategory(data.includes('categories'))
  }, [data])

  useEffect(() => {
    if (data !== 'categories') {
      setCategoryData(user?.categories)
    }
  }, [data, user])


  useEffect(() => {
    if (user.categories) setCategoryData(user?.categories);
  }, [user]);

  const onChangeaCategory = (e) => {
    if (e.target.checked && !categoryData?.includes(e.target.value)) {
      setCategoryData([...categoryData, e.target.value]);
    } else {
      const deleteCategory = categoryData?.filter((data) => data !== e.target.value);
      setCategoryData(deleteCategory);
    }
  };

  const categoryHandler = async (e) => {
    e.preventDefault();
    dispatch(editUserConfigs(token, { categories: categoryData}));
  };

  useEffect(() => {
    categoriesData(categoryData);
  }, [props, categoryData, categoriesData]);

  const showdata = () => {
    setEditCategory(true);
    setData('categories')
  };

  useEffect(() => {
    if (editUserConfigsData?.status === "succeeded") {
      refetchUser();
      setEditCategory(false);
      dispatch(editUserConfigsAction.editUserConfigsReset());
    } else if (editUserConfigsData?.status === "failed") {
      setCategoryData(user?.categories);
      setEditCategory(false);
      dispatch(editUserConfigsAction.editUserConfigsReset());
    }
  }, [dispatch, editUserConfigsData, refetchUser, user?.categories])

  return (
    <LanguageContext.Consumer>
      {(ctx) => {
        return (
          <>
            <ComponentsTitle
              title={
                
                ctx.data?.categories[ctx.language]
              }
            />
            <form
              onSubmit={categoryHandler}
              className={`${classes.gap_20} w-100 flex-wrap d-flex`}
            >
              <UserCategories
                checkedData={categoryData}
                editCategoryClick={showdata}
                onChangeaCategory={onChangeaCategory}
                hidden={true}
              />
              {editCategory  && (
                <ChangeDataButtons cancel={cancel} />
              )}
            </form>
          </>
        );
      }}
    </LanguageContext.Consumer>
  );
};

export default EditCategory;
